import { Colors } from "./Colors"

const tags = {
    // bold: {
    //     fontFamily: Fonts.InterBold,
    // },
    bullet: {
        wrap: {
            mode: 'word',
            width: 700
        },
        x: 20

    },
}

export {
    tags
}